import { API_URL } from "../../../utils/config";

export const WIFICALL_USERS_URL = `${API_URL}/wificall/users`;
export const WIFICALL_DIRECTORY_URL = `${API_URL}/yellowpage/csv/1`;